/** Production site origin - used for canonical URLs, sitemap, and Open Graph. */
export const SITE_ORIGIN = 'https://ridemaadi.scolica.com';
export const SITE_NAME = 'RideMaadi';
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/logo-pageload.png`;

/** @returns Canonical URL (home uses trailing slash). */
export function canonicalUrl(path: string): string {
  if (path === '/') return `${SITE_ORIGIN}/`;
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}

export function startGoogleSignIn(returnTo = '/dashboard'): void {
  window.location.href = `/api/auth/google/start?returnTo=${encodeURIComponent(returnTo)}`;
}
